export default __webpack_public_path__ + "static/media/transferred.e7831405.png";